import { CompanyActions } from '../actions/company';
import { Company } from '../../models/Company';

export interface CompanyState {
  companies: Company[];
}

const initialState: CompanyState = {
  companies: [],
};

export default (state = initialState, action: CompanyActions) => {
  switch (action.type) {
    case 'GET_COMPANIES_SUCCESS':
      return {
        ...state,
        companies: action.payload.companies,
      };
    default:
      return state;
  }
};
